import React from 'react';

interface DAOBadge {
    name: string;
    logo: string;
    link: string;
}

interface DAOBadgesProps {
    badges: DAOBadge[];
    className?: string;
}

export const DAOBadges: React.FC<DAOBadgesProps> = ({
    badges,
    className = '',
}) => {
    return (
        <div className={`curator-hero-badges ${className}`}>
            {badges.map((badge, index) => (
                <a
                    key={index}
                    href={badge.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="curator-dao-badge"
                >
                    <img src={badge.logo} alt={badge.name} />
                    <span>{badge.name}</span>
                </a>
            ))}
        </div>
    );
};

export default DAOBadges;
